import { render, staticRenderFns } from "./AppointmentsList.vue?vue&type=template&id=611f66f2"
import script from "./AppointmentsList.vue?vue&type=script&lang=js"
export * from "./AppointmentsList.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsList.vue?vue&type=style&index=0&id=611f66f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports